import axios from "axios";
import { getToken } from "./auth";

const isProd = process.env.NODE_ENV === "production";

const apiUrl = isProd
  ? "https://portalstars.com.br/api-portal"
  : "http://localhost:3333";

const api = axios.create({
  baseURL: apiUrl,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
